import {
  PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_BEGIN,
  PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_SUCCESS,
  PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_FAILURE,
  PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function apicallToAddFields(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId);
    console.log('8787', args, args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}xanoNew/updateTables/${args.upid}`,
        args.savefieldsobj,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_SUCCESS,
            data: res,
          });
          resolve(res);
          console.log('fields add done', res);
        },

        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error while adding fields');
        },
      );
    });

    return promise;
  };
}

export function dismissApicallToAddFieldsError() {
  return {
    type: PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_BEGIN:
      return {
        ...state,
        apicallToAddFieldsPending: true,
        apicallToAddFieldsError: null,
      };

    case PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_SUCCESS:
      return {
        ...state,
        apicallToAddFieldsPending: false,
        apicallToAddFieldsError: null,
      };

    case PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_FAILURE:
      return {
        ...state,
        apicallToAddFieldsPending: false,
        apicallToAddFieldsError: action.data.error,
      };

    case PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_DISMISS_ERROR:
      return {
        ...state,
        apicallToAddFieldsError: null,
      };

    default:
      return state;
  }
}
